export interface SkillLevelDescription {
  title: string;
  body: string;
}

export const SKILL_LEVEL_DESCRIPTIONS: SkillLevelDescription[] = [
  {
    title: 'Brand new',
    body: 'No experience yet. Learning the rules, scoring, and basic movements. Still getting comfortable making consistent contact and keeping the ball in play.',
  },
  {
    title: 'Beginner',
    body: 'Can rally a bit and understands the basic rules and positioning. Focused on consistency and fundamentals (serve/return, footwork, and simple shot control).',
  },
  {
    title: 'Intermediate',
    body: 'Comfortable rallying with control and starting to play with intention. Can place shots, handle moderate pace, and adapt to different opponents.',
  },
  {
    title: 'Advanced',
    body: 'Consistent under pressure with strong placement and tactical play. Uses variety (pace, height, spin/angle) and reads the game well at faster speed.',
  },
  {
    title: 'Pro',
    body: 'Elite-level execution with high consistency, speed, and decision-making. Competes at a high level and controls points with precision and strategy.',
  },
];
